export default function About() {
  return (
    <section id="about" className="container-responsive cv-auto py-16">
      <div className="prose prose-neutral dark:prose-invert max-w-3xl">
        <h2>Approach</h2>
        <p>
          We prioritize clarity, performance, and maintainability.
          Accessibility, responsive design, and SEO are first-class citizens. We
          deliver quickly without compromising quality, with strong
          collaboration and documentation.
        </p>
      </div>
    </section>
  )
}
